// FlexRow.tsx
import { Box, BoxProps } from '@mui/material'
import * as React from 'react'

type FlexRowProps = BoxProps & {
  gap?: number
  align?: BoxProps['alignItems']
  justify?: BoxProps['justifyContent']
  wrap?: BoxProps['flexWrap']
  children: React.ReactNode
}

const FlexRow: React.FC<FlexRowProps> = ({
  gap = 2,
  align = 'center',
  justify = 'flex-start',
  wrap = 'nowrap',
  sx,
  children,
  ...rest
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: align,
        justifyContent: justify,
        gap,
        flexWrap: wrap,
        width: '100%',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}

export default FlexRow
